// B4: a call with its own lifecycle outlives a clean turn end (a provider's `result` does not
// close a subagent or a delivery to another session); only a deadline or an unclean end sweeps it.
import { peerMessageFromToolCall, type PeerToolEntry } from "./peer-message.js";

/** The measured worst sidechain is ~11 min after `result` (claude/agent.ts:5032-5046). */
export const LONG_LIVED_SETTLE_MS = 30 * 60_000;

/** A subagent (its launch's id), or a delivery to another session or agent (PEER_TOOLS). */
export function outlivesCleanTurnEnd(entry: PeerToolEntry & { subagentId?: string }): boolean {
  return entry.subagentId !== undefined || peerMessageFromToolCall(entry) !== undefined;
}
